// Core/Third Party
import { Component, OnInit, AfterViewInit, ViewChild, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TruncateCharactersPipe } from '../../../pipes/truncate.pipe'
// Components/Services/Directives/etc.
import { IContractor } from '../../../models/contractor.interface';
import { DialogContractorReviewsComponent } from './dialog-contractor-reviews/dialog-contractor-reviews.component';

import { SelectionModel } from '@angular/cdk/collections';
import { ContractorApiService } from '../../../services/data/contractor-api.service';
import { ZipCodeApiService } from '../../../services/data/zipcode-api.service';
import { IZipCode } from '../../../models/zipcode.interface';
import { take, takeLast, debounce } from 'rxjs/operators';
import { Observable, of, timer } from 'rxjs';
import { UtilityService } from '../../../services/utility/utility.service';
import { IHelp } from '../../../models/help.interface';
import { HelpApiService } from '../../../services/data/help-api.service';
import { AppLoadService } from '../../../services/app-load.service';
import { MatPaginator } from '@angular/material/paginator';
import { cloneDeep } from 'lodash';
import { MatTableDataSource } from '@angular/material/table';


// Interfaces

@Component({
    selector: 'ebb-contractor-search',
    templateUrl: './contractor-search.component.html',
    styleUrls: ['./contractor-search.component.scss'],
    standalone: false
})
export class ContractorSearchComponent implements OnInit, AfterViewInit {
  public pageTitle = 'Contractor Directory';

  public listContractor: IContractor[] = [];
  public listContractorFiltered: IContractor[] = [];
  public pagedList: IContractor[] = [];
  public listZip: IZipCode[] = [];

  public dataSourceTable = new MatTableDataSource<IContractor>([]);
  public dataSourceSentEstimateTable = new MatTableDataSource<IContractor>([]);
  public dataSourceSelectedContractorTable = new MatTableDataSource<
    IContractor
  >([]);
  public selection = new SelectionModel<IContractor>(true, []);
  public dataResultsLength = 0;
  public displayedColumns: string[] = [
    'checkbox',
    'bizLogo',
    'bizId',
    'bizContact',
    'action'
  ];
  public displayedColumnsComplete: string[] = [
    'bizSelectedIcon',
    'bizId',
    'bizContact'
  ];
  public tablePageSizeOptions: number[] = [5, 10, 25];

  @ViewChild(MatPaginator) dataPaginator: MatPaginator;

  public waitForListingToShow = false;
  public noSearchResults = false;

  public formSearch: FormGroup;
  public formIntroSelectSearch: FormGroup;
  public formIntroEstimateSearch: FormGroup;
  public formConfirmContractor: FormGroup;
  public radlat1: number;
  public radlat2: number;
  public theta: number;
  public radtheta: number;
  public dist: number;
  public newSearchDistance: number;
  public oldSearchDistance: number;
  public disableSendRequest = true; //disable send button
  public disableSelection = false; //disable selection box on contractor
  public formView:
    | 'search'
    | 'intro'
    | 'estimateRequested'
    | 'contractorSelected' = 'search';
  public countSentEstimateRequests = 0;
  public appZipLoaded: string;
  public zipLat: number;
  public zipLong: number;
  public listMaxCountLimit = 5000; //initial limit to 5000 for standard searches
  public listMaxSelectLimit = 0;
  public startOverEmitUsed: boolean;
  public selectContractorSendEstimateRequestChecked = true;
  public _openOption: 'default' | 'intro' | 'estimate' | '2ndBid';

  public listHelp: IHelp[] = [];
  public textContractorSearchIntroduction: string;
  public textContractorEstimateRequested: string;
  public screenWidth: any;
  public screenHeight: any;
  public isMobile: boolean;
  public showMore = false;
  public _programtypes = '';
  public retrofitTypeFilter: string;

  @Input() appZIP: string;
  @Input() contractorSearchDistance: string;
  @Input() contractorSearchPhrase: string;
  @Input() contractorSearchFilterHide: null | 'all' | 'zip' | 'phrase';
  @Input() dwellingLat: number;
  @Input() dwellingLong: number;
  @Input() isPortal: boolean;
  @Input() genericLogo: string;
  @Input() businessLogoRoot: string;
  @Input() programtypes: string;

  @Input('openOption')
  set openOption(value: 'default' | 'intro' | 'estimate' | '2ndBid') {
    this._openOption = value;
    this.SetopenOption(value);
  }
  public cardLayout = 100 / 3 + '%';

  @Output() sendRequestForEstimateEmit = new EventEmitter<{
    contractor: IContractor;
    contactPreference: number;
  }>();
  @Output() closeEmit = new EventEmitter<boolean>();
  @Output() selectContractorEmit = new EventEmitter<string>();

  constructor(
    private apiContractor: ContractorApiService,
    public dialog: MatDialog,
    private readonly dialogContractorReviews: MatDialog,
    private cd: ChangeDetectorRef,
    public readonly apiZipCode: ZipCodeApiService,
    private readonly fb: FormBuilder,
    private readonly apiHelp: HelpApiService,
    public readonly util: UtilityService,
    private appLoadService: AppLoadService
  ) {}

  private SetopenOption(value: string) {
    if (value === 'estimate') {
      this.displayedColumns = ['checkbox', 'bizLogo', 'bizId', 'bizContact'];
      this.pageTitle = 'Send Request for Estimate';
      this.tablePageSizeOptions = [5, 10, 15];
      this.listMaxCountLimit = 0;
      this.formView = 'search';
    } else if (value === 'intro') {
      this.formView = 'intro';
      this.pageTitle = 'Contractor Directory';
      this.loadHelpText();
    } else {
      if (this.isPortal) {
        this.displayedColumns = ['bizLogo', 'bizId', 'bizContact', 'action'];
      } else {
        this.displayedColumns = [
          'bizLogo',
          'bizId',
          'bizContact',
          'bizRetrofitProgram'
        ];
      }
      this.formView = 'search';
    }
  }

  onResize(event) {
    this.screenWidth = event.target.innerWidth;
  }

  doCheckIsMobile(debug = false) {
    this.isMobile = window.innerWidth < 768;
    if (debug) {
      console.log(`window.innerWidth: ${window.innerWidth}
                  this.isMobile: ${this.isMobile}`);
    }
  }

  ngOnInit() {
    this.SetopenOption(this._openOption);
    //console.warn(this.isPortal);
    this.doCheckIsMobile(false);
    this.initializeForms();
    if (this.appLoadService.readEnvironSettings().programTypeCodeOptionSet) {
      this._programtypes = this.appLoadService.readEnvironSettings().programTypeCodeOptionSet;
    }
    if (!this.isPortal) {
      let _retrofitProgramsFilter = String(
        this.formSearch.get('retrofitProgramsFilter').value
      );
      if (_retrofitProgramsFilter == '') {
        this.formSearch.get('retrofitProgramsFilter').setValue(['All']);
        _retrofitProgramsFilter = 'All';
      }
    }
  }

  ngAfterViewInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
  }

  private initializeForms(): void {
    this.formSearch = this.fb.group({
      searchZIP: ['', [Validators.pattern(/^[0-9]{5}$/)]],
      searchDistance: '',
      searchPhrase: '',
      requestNumber: '',
      retrofitProgramsFilter: '',
      requestMethod: '700000002'
    });
    this.formIntroEstimateSearch = this.fb.group({
      searchZIP: ['', [Validators.required, Validators.pattern(/^[0-9]{5}$/)]],
      searchDistance: ['', [Validators.required]]
    });
    this.formIntroSelectSearch = this.fb.group({
      searchPhrase: ['', [Validators.required]]
    });

    this.formConfirmContractor = this.fb.group({
      requestEstimate: false
    });

    this.formSearch.get('searchZIP').setValue(this.appZIP);
    this.formIntroEstimateSearch.get('searchZIP').setValue(this.appZIP);
    this.formSearch
      .get('searchDistance')
      .setValue(
        this.contractorSearchDistance ? this.contractorSearchDistance : ''
      );
    this.formSearch.get('searchPhrase').setValue(this.contractorSearchPhrase);
    this.setRequiredValidators();
    if (this.appZIP) {
      const searchDistance = this.formSearch.get('searchDistance');
      searchDistance.setValidators([Validators.required]);
      searchDistance.markAsTouched();
    }
    if (this.appZIP && this.contractorSearchDistance) {
      this.loadData('zip');
    } else if (this.contractorSearchPhrase) {
      this.loadData('name');
    }

    this.formSearch.get('searchZIP').valueChanges.subscribe(selectedValue => {
      const searchDistance = this.formSearch.get('searchDistance');
      if (selectedValue) {
        this.loadData('zip');
        this.formSearch.get('searchPhrase').reset('');
        this.setRequiredValidators();
        if (
          this.util.isEmpty(searchDistance.validator) ||
          this.util.isEmpty(
            searchDistance.validator({} as AbstractControl).required
          )
        ) {
          searchDistance.setValidators([Validators.required]);
          searchDistance.markAsTouched();
          searchDistance.updateValueAndValidity();
        }
      } else {
        searchDistance.clearValidators();
      }
    });

    this.formSearch
      .get('searchDistance')
      .valueChanges.subscribe(selectedValue => {
        if (selectedValue) {
          this.loadData('zip');
          this.formSearch.get('searchPhrase').reset('');
          this.setRequiredValidators();
        }
      });

    this.formSearch
      .get('searchPhrase')
      .valueChanges.pipe(debounce(() => timer(500)))
      .subscribe(selectedValue => {
        if (selectedValue) {
          this.loadData('name');
          this.formSearch.get('searchZIP').reset('');
          this.formSearch.get('searchDistance').reset('');
          this.setRequiredValidators();
        }
      });
    this.formSearch
      .get('retrofitProgramsFilter')
      .valueChanges.pipe(debounce(() => timer(500)))
      .subscribe(selectedValue => {
        if (selectedValue !== '') {
          const newSearchZip = String(
            this.formSearch.get('searchZIP').value
          ).trim();
          const newSearchDistance = String(
            this.formSearch.get('searchDistance').value
          );

          if (newSearchZip.length === 5 && newSearchDistance.length > 0) {
            this.loadData('zip');
          } else {
            this.loadData('name');
          }
          this.setRequiredValidators();
        } else {
          if (!this.isPortal) {
            let _retrofitProgramsFilter = this.formSearch.get(
              'retrofitProgramsFilter'
            );
            if (_retrofitProgramsFilter.value == '') {
              _retrofitProgramsFilter.setValidators([Validators.required]);
              _retrofitProgramsFilter.markAsTouched();
            }
          }
        }
      });
    this.oldSearchDistance = 5000;
    this.dataSourceTable.data = this.listContractor;
  }
  private setRequiredValidators() {
    let szip = this.formSearch.get('searchZIP').value;
    let searchDistance = this.formSearch.get('searchDistance').value;
    let searchPhrase = this.formSearch.get('searchPhrase').value;

    if (szip == undefined) {
      szip = '';
      this.formSearch.get('searchZIP').setValue("");
    }
    if (searchDistance == undefined) {
      searchDistance = '';
      this.formSearch.get('searchDistance').setValue("");
    }
    if (searchPhrase == undefined) {
      searchPhrase = '';
      this.formSearch.get('searchPhrase').setValue("");
    }
    if (szip == '' && searchDistance == '' && searchPhrase == '') {
      this.formSearch.get('searchZIP').setValidators([Validators.required]);
 
      this.formSearch.get('searchDistance').setValidators([Validators.required]);
 
      this.formSearch.get('searchPhrase').setValidators([Validators.required]);
     
    }

    if (szip != '' || searchDistance != '') {
      this.formSearch.get('searchDistance').setValidators([Validators.required]);
      if(searchDistance == ''){
      this.formSearch.get('searchDistance').setErrors({'required':true});}
      this.formSearch.get('searchDistance').markAsTouched();

      this.formSearch.get('searchZIP').setValidators([Validators.required]);
      if(szip == ''){
      this.formSearch.get('searchZIP').setErrors({'required':true});}
      this.formSearch.get('searchZIP').markAsTouched();
      this.formSearch.get('searchPhrase').setValidators(null);
      this.formSearch.get('searchPhrase').setErrors({'required':false});
      this.formSearch.updateValueAndValidity();
    }

    if (searchPhrase != '') {
      this.formSearch.get('searchZIP').setValidators(null);

      this.formSearch.get('searchDistance').setValidators(null);


      this.formSearch.get('searchPhrase').setValidators([Validators.required]);

      this.formSearch.get('searchPhrase').markAsTouched();
      this.formSearch.updateValueAndValidity();
    }
   
  }
 
  private loadHelpText(): void {
    this.apiHelp.getList().subscribe(
      data => {
        this.listHelp = cloneDeep(JSON.parse(JSON.stringify(data)));

        const indexHelpContractor = this.listHelp.findIndex(
          i => i.name.toLowerCase() === 'contractorsearchintroduction'
        );
        this.textContractorSearchIntroduction = this.listHelp[
          indexHelpContractor
        ].answer;

        const indexHelpProfile = this.listHelp.findIndex(
          i => i.name.toLowerCase() === 'contractorestimaterequested'
        );
        this.textContractorEstimateRequested = this.listHelp[
          indexHelpProfile
        ].answer;
      },
      error => console.log(error)
    );
  }

  private getZipCodes(): Observable<IZipCode[]> {
    return this.apiZipCode.getDetailed().pipe(take(1));
  }

  private loadData(searchType: 'zip' | 'name'): void {
    const newSearchZip = String(this.formSearch.get('searchZIP').value).trim();
    const newSearchDistance = String(
      this.formSearch.get('searchDistance').value
    );
    const newSearchPhrase = String(
      this.formSearch.get('searchPhrase').value
    ).trim();
    const _retrofitProgramsFilter = String(
      this.formSearch.get('retrofitProgramsFilter').value
    );
    //if input take input, otherwise take stored value from appLoad

    let programtypes = this.programtypes
      ? this.programtypes
      : this._programtypes === 'FEMA|EBB|ESS'
      ? 'All'
      : this._programtypes;

    if (_retrofitProgramsFilter != '') {
      programtypes = _retrofitProgramsFilter;
    }

    //if (window['program']) {
    //  programtypes = window['program'];
    //  this.appLoadService.readEnvironSettings().programTypeCodeOptionSet = programtypes;
    // }

    if (
      searchType === 'zip' &&
      (this.util.isEmpty(newSearchZip) ||
        this.util.isEmpty(newSearchDistance)) &&
      this.util.isEmpty(newSearchPhrase)
    ) {
      //search empty
      this.appZipLoaded = '';

      this.listContractor.length = 0;
      this.pageDirectoryData(this.listContractor);
    }
    //perform search using proximity
    else if (
      searchType === 'zip' &&
      newSearchZip &&
      newSearchZip.length === 5 &&
      this.appZipLoaded !== newSearchZip &&
      Number(newSearchZip)
    ) {
      this.formSearch.get('searchZIP').markAsTouched();
      this.waitForListingToShow = true;
      this.getZipCodes().subscribe(
        data => {
          this.listZip = cloneDeep(data);
          const zipMatch = this.listZip.filter(
            zipMatch => zipMatch.name === newSearchZip
          );

          if (zipMatch && zipMatch[0]) {
            this.zipLat = Number(zipMatch[0].latitude);
            this.zipLong = Number(zipMatch[0].longitude);
          } else {
            this.zipLat = null;
            this.zipLat = null;
          }

          this.appZipLoaded = newSearchZip;
          this.retrofitTypeFilter = programtypes;
          this.apiContractor
            .getContractorListZip(this.appZipLoaded, this.retrofitTypeFilter)
            .subscribe(
              data => {
                var datalist = cloneDeep(data);
                this.listContractor.splice(
                  0,
                  this.listContractor.length,
                  ...datalist
                );
                this.pageDirectoryData(this.listContractor);
                this.onZipSearchFilter();
              },
              error => console.warn(error)
            );
            
        },
        error => {
          console.warn(`${JSON.stringify(error)}`);
        }
      );
    }
    //perform search using proximity
    else if (
      searchType === 'zip' &&
      newSearchZip &&
      newSearchZip.length === 5
    ) {
      this.onZipSearchFilter();
    }
    //perform name search if zip is empty
    else if (
      searchType === 'name' &&
      newSearchPhrase &&
      newSearchPhrase.length > 0
    ) {
      this.appZipLoaded = '';
      this.pageDirectoryData(this.listContractor);
      this.waitForListingToShow = true;
      this.apiContractor
        .getContractorListFilter(newSearchPhrase, programtypes)
        .subscribe(
          _data => {
            var data = cloneDeep(_data);
            this.listContractor.splice(0, this.listContractor.length, ...data);
            this.listContractorFiltered = this.listContractor;
            this.pageDirectoryData(this.listContractor);
            this.waitForListingToShow = false;
          },
          error => console.warn(error)
        );
    }
  }

  public getZipErrorMessage() {
    const field = this.formSearch.get('searchZIP');

    if (field.hasError('required')) {
      return 'enter ZIP code';
    }

    return field.hasError('pattern') ? 'Enter valid ZIP Code' : '';
  }

  public getContractorImage(contact: IContractor): string {
    return contact.id
      ? `${this.businessLogoRoot}${contact.id}`
      : this.genericLogo;
  }

  public getContractorImageError(event) {
    event.target.src = this.genericLogo;
  }

  public printTable(containerId: string) {
    const printContent = document.getElementById(containerId);
    const WindowPrt = window.open(
      '',
      '',
      'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0'
    );
    const printStyle = document.createElement('style');
    printStyle.innerHTML =
      '.print-hide { display: none; } tr {page-break-inside: avoid;page-break-before:auto} ';
    WindowPrt.document.write(
      '<html lang="en-US"><head></head><body>' +
        printContent.innerHTML +
        '</body></html>'
    );
    WindowPrt.document.head.append(printStyle);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
  }

  public isFormIncomplete() {
    const searchZIP = this.formSearch.get('searchZIP');
    const searchDistance = this.formSearch.get('searchDistance');
    const searchPhrase = this.formSearch.get('searchPhrase');
    const requestNumber = this.formSearch.get('requestNumber');

    if (this._openOption === 'estimate') {
      return (
        ((this.util.isEmpty(searchZIP.value) ||
          this.util.isEmpty(searchDistance.value)) &&
          this.util.isEmpty(searchPhrase.value)) ||
        this.util.isEmpty(requestNumber.value)
      );
    } else {
      return (
        (this.util.isEmpty(searchZIP.value) ||
          this.util.isEmpty(searchDistance.value)) &&
        this.util.isEmpty(searchPhrase.value)
      );
    }
  }

  public onSubmitFormIntroEstimateSearch() {
    if (this.formIntroEstimateSearch.valid) {
      const searchZIPSource = this.formIntroEstimateSearch.get('searchZIP');
      const searchDistanceSource = this.formIntroEstimateSearch.get(
        'searchDistance'
      );
      const searchZIP = this.formSearch.get('searchZIP');
      const searchDistance = this.formSearch.get('searchDistance');

      this.openOption = 'estimate';
      this.contractorSearchFilterHide = 'all';
      searchZIP.setValue(searchZIPSource.value);
      searchDistance.setValue(searchDistanceSource.value);

      if (this.formSearch.get('requestNumber').valid) {
        this.onChangeCheckListToSubmit(
          this.formSearch.get('requestNumber').value
        );
      }
    }
  }

  public onSubmitFormIntroSelectSearch() {
    if (this.formIntroSelectSearch.valid) {
      const searchPhraseSource = this.formIntroSelectSearch.get('searchPhrase');
      const searchPhrase = this.formSearch.get('searchPhrase');

      this.openOption = 'default';
      this.contractorSearchFilterHide = 'zip';
      searchPhrase.setValue(searchPhraseSource.value);
    }
  }

  public formatLink(value: string) {
    if (value) {
      value = value.toLowerCase();
      if (value.startsWith('http')) {
        return value;
      } else {
        return `http://${value}`;
      }
    }
    return '';
  }

  public onChangeCheckListToSubmit(max: any): void {
    this.listMaxSelectLimit = max === 'choice' ? 0 : Number(max);
    this.listMaxCountLimit = max === 'choice' ? 5000 : Number(max);
    this.pageDirectoryData(this.listContractorFiltered);
  }

  public onClickSendRequestForEstimate(): void {
    const list = this.dataSourceTable.data;
    const rM = Number(this.formSearch.get('requestMethod').value);
    const listSentEstimateContractor: IContractor[] = [];
    this.countSentEstimateRequests = 0;
    for (let i = 0; i < this.listMaxCountLimit && i < list.length; i++) {
      if (this.selection.isSelected(this.dataSourceTable.data[i])) {
        this.sendRequestForEstimateEmit.emit({
          contractor: this.dataSourceTable.data[i],
          contactPreference: rM
        });
        this.countSentEstimateRequests++;
        listSentEstimateContractor.push(this.dataSourceTable.data[i]);
      }
    }
    this.dataSourceSentEstimateTable.data = listSentEstimateContractor;
    this.formView = 'estimateRequested';
  }

  public checkboxLabel(row?: IContractor): string {
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} ${
      row.businessName
    }`;
  }

  private pageDirectoryData(paginateList: IContractor[]): void {
    if (this.formSearch.disabled) {
      return; //disabling causes reload of data, skip
    }
    if (Array.isArray(paginateList) && paginateList.length > 0) {
      this.dataSourceTable.data = paginateList.slice(
        0,
        paginateList.length < this.listMaxCountLimit
          ? paginateList.length
          : this.listMaxCountLimit
      );
      this.noSearchResults = false;
      this.dataResultsLength = this.dataSourceTable.data.length;
    } else {
      this.dataSourceTable.data = [];
      this.noSearchResults = true;
      this.dataResultsLength = 0;
    }

    if (this._openOption === 'estimate') {
      for (let i = 0; i < this.dataSourceTable.data.length; i++) {
        if (i < this.listMaxSelectLimit) {
          this.selection.select(this.dataSourceTable.data[i]);
        } else {
          this.selection.deselect(this.dataSourceTable.data[i]);
        }
      }
    }

    this.waitForListingToShow = false;
    this.cd.detectChanges();
  }

  public onCheckValidators(controlName: string): boolean {
    const retVal =
      this.formSearch.get(controlName).errors &&
      (this.formSearch.get(controlName).dirty ||
        this.formSearch.get(controlName).touched);

    const rN = this.formSearch.get('requestNumber').value;
    const rM = this.formSearch.get('requestMethod').value;
    if (rN && rN.length > 0 && (rM && rM.length > 0))
      this.disableSendRequest = false;
    else this.disableSendRequest = true;

    return retVal;
  }

  public onSelectContractor(item: IContractor): void {
    this.formView = 'contractorSelected';
    this.dataSourceSelectedContractorTable.data = [item];
  }

  public onSelectContractorConfirm(): void {
    const contractor = this.dataSourceSelectedContractorTable.data[0];
    if (this.formConfirmContractor.get('requestEstimate').value) {
      this.sendRequestForEstimateEmit.emit({
        contractor: contractor,
        contactPreference: 700000002
      }); //phone or email
    }
    this.selectContractorEmit.emit(contractor.id);
  }

  public onClickReturnToSearch(): void {
    this.doCheckIsMobile(false);
    this.formView = 'search';
  }

  public onToggleMoreContractor(event, item): void {
    event.preventDefault();
    item.showMore = item.showMore ? false : true;
  }

  public onShowReviews(event, contractor: IContractor): void {
    event.preventDefault();
    this.apiContractor.getContractorReviews(contractor.id).subscribe(
      data => {
        const dialogRef = this.dialogContractorReviews.open(
          DialogContractorReviewsComponent,
          {
            width: '600px',
            height: '600px',
            data: {
              reviews: data,
              name: contractor.businessName,
              licenseNo: contractor.contractorLicenseNumber,
              previewLimit: 3
            }
          }
        );
      },
      error => console.warn(error)
    );
  }

  public onClickClose(): void {
    this.closeEmit.emit(true);
  }

  public onClickStartOver(): void {
    this.doCheckIsMobile(false);
    this.formView = 'intro';
    const searchPhraseSource = this.formIntroSelectSearch.get('searchPhrase');
    const searchPhrase = this.formSearch.get('searchPhrase');
    if (!this.util.isEmpty(searchPhrase.value)) {
      searchPhraseSource.setValue(searchPhrase.value);
    }
  }

  public onZipSearchFilter(): void {
    this.newSearchDistance = Number(
      this.formSearch.controls.searchDistance.value
    );
    const stringSearchDistance: string = this.formSearch.controls.searchDistance
      .value;
    this.listContractorFiltered = this.listContractor;
    const _retrofitProgramsFilter = String(
      this.formSearch.get('retrofitProgramsFilter').value
    );
    if (_retrofitProgramsFilter.length > 0) {
      if (_retrofitProgramsFilter == 'EBB') {
        this.listContractorFiltered = this.listContractorFiltered.filter(
          (contractor: IContractor) => contractor.contractorInDirectory === true
        );
      }
      if (_retrofitProgramsFilter === 'ESS') {
        this.listContractorFiltered = this.listContractorFiltered.filter(
          (contractor: IContractor) =>
            contractor.essContractorInDirectory === true
        );
      }
      if (_retrofitProgramsFilter === 'EMR') {
        this.listContractorFiltered = this.listContractorFiltered.filter(
          (contractor: IContractor) =>
            contractor.emrContractorInDirectory === true
        );
      }
    }

    if (stringSearchDistance !== '5000') {
      this.calculateDistances();
      this.listContractorFiltered = this.listContractorFiltered.filter(
        (contractor: IContractor) =>
          contractor.distanceToDwelling <= this.newSearchDistance &&
          contractor.distanceToDwelling !== -1
      );
    }
    this.oldSearchDistance = this.newSearchDistance;

    this.pageDirectoryData(this.listContractorFiltered);
  }

  private calculateDistances() {
    const newSearchZip = String(this.formSearch.get('searchZIP').value);

    for (const i of this.listContractor) {
      i.distanceToDwelling = this.calculateDistance(
        parseFloat(i.address2_Latitude),
        parseFloat(i.address2_Longitude),
        newSearchZip
      );
    }
  }

  private calculateDistance(
    contractorLat: number,
    contractorLong: number,
    newSearchZip: string
  ): number {
    //if we do not have a zip code selected then use the dwelling
    let dwellingLatLocal = this.zipLat;
    let dwellingLongLocal = this.zipLong;
    if (this.appZIP === newSearchZip && this.dwellingLat && this.dwellingLong) {
      dwellingLatLocal = this.dwellingLat;
      dwellingLongLocal = this.dwellingLong;
    }

    if (
      (dwellingLatLocal === contractorLat &&
        dwellingLongLocal === contractorLong) ||
      this.areInvalid(dwellingLatLocal, dwellingLongLocal)
    ) {
      return -1;
    } else {
      this.radlat1 = (Math.PI * dwellingLatLocal) / 180;
      this.radlat2 = (Math.PI * contractorLat) / 180;
      this.theta = dwellingLongLocal - contractorLong;
      this.radtheta = (Math.PI * this.theta) / 180;
      this.dist =
        Math.sin(this.radlat1) * Math.sin(this.radlat2) +
        Math.cos(this.radlat1) *
          Math.cos(this.radlat2) *
          Math.cos(this.radtheta);
      if (this.dist > 1) {
        this.dist = 1;
      }
      this.dist = Math.acos(this.dist);
      this.dist = (this.dist * 180) / Math.PI;
      this.dist = this.dist * 60 * 1.1515;
      return this.dist;
    }
  }

  private areInvalid(lat: number, long: number): boolean {
    if (
      lat == null ||
      lat === undefined ||
      Number.isNaN(lat) ||
      long == null ||
      long === undefined ||
      Number.isNaN(long)
    ) {
      return true;
    } else {
      return false;
    }
  }
  public showRetrofitPrograms(contractor: IContractor): string {
    let retrofitPrograms = [];
  
    if (contractor.contractorInDirectory) {
      retrofitPrograms.push("EBB");
    }
    if (contractor.essContractorInDirectory) {
      retrofitPrograms.push("ESS");
    }
    if (contractor.emrContractorInDirectory) {
      retrofitPrograms.push("EMR");
    }
  
    return retrofitPrograms.join(",");
  }
  
  
}
